// Generated by ReScript, PLEASE EDIT WITH CARE
/* @generated */
'use strict';

let ReactRelay = require("react-relay");
let RescriptRelay = require("rescript-relay/src/RescriptRelay.bs.js");
let DevicePixelRatio = require("../v5/common/DevicePixelRatio.bs.js");
let Primitive_option = require("@rescript/runtime/lib/js/Primitive_option.js");

function makeRefetchVariables(after, areaIds, before, buyerNeedPropertyTypes, buyerNeedStatuses, first, keywords, last, maxPrice, minPrice, rentalMode) {
  return {
    after: after,
    areaIds: areaIds,
    before: before,
    buyerNeedPropertyTypes: buyerNeedPropertyTypes,
    buyerNeedStatuses: buyerNeedStatuses,
    first: first,
    keywords: keywords,
    last: last,
    maxPrice: maxPrice,
    minPrice: minPrice,
    rentalMode: rentalMode
  };
}

let Types = {
  makeRefetchVariables: makeRefetchVariables
};

let variablesConverter = {};

function convertVariables(v) {
  return RescriptRelay.convertObj(v, variablesConverter, undefined, undefined);
}

let wrapResponseConverter = {"__root":{"":{"f":""}}};

function convertWrapResponse(v) {
  return RescriptRelay.convertObj(v, wrapResponseConverter, undefined, null);
}

let responseConverter = {"__root":{"":{"f":""}}};

function convertResponse(v) {
  return RescriptRelay.convertObj(v, responseConverter, undefined, undefined);
}

let Internal = {
  variablesConverter: variablesConverter,
  variablesConverterMap: undefined,
  convertVariables: convertVariables,
  wrapResponseConverter: wrapResponseConverter,
  wrapResponseConverterMap: undefined,
  convertWrapResponse: convertWrapResponse,
  responseConverter: responseConverter,
  responseConverterMap: undefined,
  convertResponse: convertResponse,
  convertWrapRawResponse: convertWrapResponse,
  convertRawResponse: convertResponse
};

function buyerNeedV5FilterableStatus_decode($$enum) {
  if ($$enum === "ACTIVE" || $$enum === "WITHDRAWN" || $$enum === "EXPIRED" || $$enum === "PURCHASED" || $$enum === "IN_CONTRACT") {
    return $$enum;
  }
}

let buyerNeedV5FilterableStatus_fromString = buyerNeedV5FilterableStatus_decode;

function forSalePropertyTypeEnumV5_decode($$enum) {
  if ($$enum === "CONDO" || $$enum === "SINGLE_FAMILY" || $$enum === "LOT" || $$enum === "MULTI_UNIT") {
    return $$enum;
  }
}

let forSalePropertyTypeEnumV5_fromString = forSalePropertyTypeEnumV5_decode;

let Utils = {
  buyerNeedV5FilterableStatus_decode: buyerNeedV5FilterableStatus_decode,
  buyerNeedV5FilterableStatus_fromString: buyerNeedV5FilterableStatus_fromString,
  forSalePropertyTypeEnumV5_decode: forSalePropertyTypeEnumV5_decode,
  forSalePropertyTypeEnumV5_fromString: forSalePropertyTypeEnumV5_fromString
};

let providedVariablesDefinition = {
  __relay_internal__pv__DevicePixelRatio: {
    providedVariable: DevicePixelRatio.get,
    get: DevicePixelRatio.get
  }
};

function makeNode(providedVariablesDefinition) {
  return ((function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "after"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "areaIds"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "before"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "buyerNeedPropertyTypes"
},
v4 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "buyerNeedStatuses"
},
v5 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "first"
},
v6 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "keywords"
},
v7 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "last"
},
v8 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "maxPrice"
},
v9 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "minPrice"
},
v10 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "rentalMode"
},
v11 = {
  "kind": "Variable",
  "name": "after",
  "variableName": "after"
},
v12 = {
  "kind": "Variable",
  "name": "before",
  "variableName": "before"
},
v13 = {
  "kind": "Variable",
  "name": "first",
  "variableName": "first"
},
v14 = {
  "kind": "Variable",
  "name": "last",
  "variableName": "last"
},
v15 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v16 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Literal",
        "name": "format",
        "value": "SHORT"
      }
    ],
    "kind": "ScalarField",
    "name": "formatted",
    "storageKey": "formatted(format:\"SHORT\")"
  }
],
v17 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "nodeId",
  "storageKey": null
},
v18 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "displayName",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/),
      (v4/*: any*/),
      (v5/*: any*/),
      (v6/*: any*/),
      (v7/*: any*/),
      (v8/*: any*/),
      (v9/*: any*/),
      (v10/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "ClientNeedsPageRelayRefetchQuery",
    "selections": [
      {
        "args": [
          (v11/*: any*/),
          (v12/*: any*/),
          (v13/*: any*/),
          (v14/*: any*/)
        ],
        "kind": "FragmentSpread",
        "name": "ClientNeedsPageRelayBuying_query"
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/),
      (v4/*: any*/),
      (v5/*: any*/),
      (v6/*: any*/),
      (v7/*: any*/),
      (v8/*: any*/),
      (v9/*: any*/),
      (v10/*: any*/),
      {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "__relay_internal__pv__DevicePixelRatio"
      }
    ],
    "kind": "Operation",
    "name": "ClientNeedsPageRelayRefetchQuery",
    "selections": [
      {
        "condition": "rentalMode",
        "kind": "Condition",
        "passingValue": false,
        "selections": [
          {
            "alias": null,
            "args": [
              (v11/*: any*/),
              {
                "kind": "Variable",
                "name": "areaIds",
                "variableName": "areaIds"
              },
              (v12/*: any*/),
              (v13/*: any*/),
              {
                "kind": "Variable",
                "name": "keywords",
                "variableName": "keywords"
              },
              (v14/*: any*/),
              {
                "kind": "Variable",
                "name": "maxPrice",
                "variableName": "maxPrice"
              },
              {
                "kind": "Variable",
                "name": "minPrice",
                "variableName": "minPrice"
              },
              {
                "kind": "Variable",
                "name": "propertyTypes",
                "variableName": "buyerNeedPropertyTypes"
              },
              {
                "kind": "Variable",
                "name": "statuses",
                "variableName": "buyerNeedStatuses"
              }
            ],
            "concreteType": "BuyerNeedV5Connection",
            "kind": "LinkedField",
            "name": "searchBuyerNeeds",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "PageInfo",
                "kind": "LinkedField",
                "name": "pageInfo",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "hasNextPage",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "endCursor",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "hasPreviousPage",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "startCursor",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "totalCount",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "BuyerNeedV5Edge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "BuyerNeedV5",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      (v15/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "headline",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "PriceRange",
                        "kind": "LinkedField",
                        "name": "priceRange",
                        "plural": false,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "Price",
                            "kind": "LinkedField",
                            "name": "minPrice",
                            "plural": false,
                            "selections": (v16/*: any*/),
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "Price",
                            "kind": "LinkedField",
                            "name": "maxPrice",
                            "plural": false,
                            "selections": (v16/*: any*/),
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "BuyerNeedAreaConnection",
                        "kind": "LinkedField",
                        "name": "areas",
                        "plural": false,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "BuyerNeedAreaEdge",
                            "kind": "LinkedField",
                            "name": "edges",
                            "plural": true,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "Area",
                                "kind": "LinkedField",
                                "name": "node",
                                "plural": false,
                                "selections": [
                                  (v15/*: any*/),
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "name",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "label",
                                    "storageKey": null
                                  },
                                  (v17/*: any*/)
                                ],
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "BuyerNeedPropertyType",
                        "kind": "LinkedField",
                        "name": "propertyTypes",
                        "plural": true,
                        "selections": [
                          (v18/*: any*/)
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "minBeds",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "createdAt",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": null,
                        "kind": "LinkedField",
                        "name": "status",
                        "plural": false,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "__typename",
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "Agent",
                        "kind": "LinkedField",
                        "name": "agent",
                        "plural": false,
                        "selections": [
                          (v15/*: any*/),
                          (v18/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "brokerage",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "ProfilePhoto",
                            "kind": "LinkedField",
                            "name": "profilePhoto",
                            "plural": false,
                            "selections": [
                              {
                                "alias": null,
                                "args": [
                                  {
                                    "kind": "Variable",
                                    "name": "ratio",
                                    "variableName": "__relay_internal__pv__DevicePixelRatio"
                                  },
                                  {
                                    "kind": "Literal",
                                    "name": "width",
                                    "value": 60
                                  }
                                ],
                                "kind": "ScalarField",
                                "name": "url",
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "membershipStatus",
                            "storageKey": null
                          },
                          (v17/*: any*/)
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "updatedAt",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": [
                          {
                            "kind": "Literal",
                            "name": "first",
                            "value": 1
                          }
                        ],
                        "concreteType": "BuyerNeedBroadcastConnection",
                        "kind": "LinkedField",
                        "name": "broadcasts",
                        "plural": false,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "BuyerNeedBroadcastEdge",
                            "kind": "LinkedField",
                            "name": "edges",
                            "plural": true,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "BuyerNeedBroadcast",
                                "kind": "LinkedField",
                                "name": "node",
                                "plural": false,
                                "selections": [
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "broadcastAt",
                                    "storageKey": null
                                  },
                                  (v17/*: any*/)
                                ],
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          }
                        ],
                        "storageKey": "broadcasts(first:1)"
                      },
                      (v17/*: any*/)
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ]
      }
    ]
  },
  "params": {
    "cacheID": "dbcc4b3c140eb84ea5322f74fc4d1289",
    "id": null,
    "metadata": {},
    "name": "ClientNeedsPageRelayRefetchQuery",
    "operationKind": "query",
    "text": "query ClientNeedsPageRelayRefetchQuery(\n  $after: String\n  $areaIds: [ID!]\n  $before: String\n  $buyerNeedPropertyTypes: [ForSalePropertyTypeEnumV5!]\n  $buyerNeedStatuses: [BuyerNeedV5FilterableStatus!]\n  $first: Int\n  $keywords: [String!]\n  $last: Int\n  $maxPrice: Int\n  $minPrice: Int\n  $rentalMode: Boolean!\n  $__relay_internal__pv__DevicePixelRatio: Float!\n) {\n  ...ClientNeedsPageRelayBuying_query_pbnwq\n}\n\nfragment AgentInfo_agent on Agent {\n  id\n  displayName\n  brokerage\n  profilePhoto {\n    url(width: 60, ratio: $__relay_internal__pv__DevicePixelRatio)\n  }\n  membershipStatus\n}\n\nfragment AreasCriteria_area on Area {\n  id\n  name\n  label\n}\n\nfragment BuyerNeedAddedDate_buyerNeedV5 on BuyerNeedV5 {\n  createdAt\n}\n\nfragment BuyerNeedAreas_buyerNeedV5 on BuyerNeedV5 {\n  areas {\n    edges {\n      node {\n        ...AreasCriteria_area\n        nodeId\n      }\n    }\n  }\n}\n\nfragment BuyerNeedPriceRange_buyerNeedV5 on BuyerNeedV5 {\n  priceRange {\n    ...PriceRangeCriteria_priceRange\n  }\n}\n\nfragment BuyerNeedPropertyAttributes_buyerNeedV5 on BuyerNeedV5 {\n  propertyTypes {\n    ...BuyerNeedPropertyAttributes_propertyTypes\n  }\n  minBeds\n}\n\nfragment BuyerNeedPropertyAttributes_propertyTypes on BuyerNeedPropertyType {\n  displayName\n}\n\nfragment BuyerNeedSearchResultTimestamp_buyerNeed on BuyerNeedV5 {\n  updatedAt\n  broadcasts(first: 1) {\n    edges {\n      node {\n        broadcastAt\n        nodeId\n      }\n    }\n  }\n}\n\nfragment BuyerNeedSearchResult_buyerNeed on BuyerNeedV5 {\n  id\n  headline\n  ...BuyerNeedPriceRange_buyerNeedV5\n  ...BuyerNeedAreas_buyerNeedV5\n  ...BuyerNeedPropertyAttributes_buyerNeedV5\n  ...BuyerNeedAddedDate_buyerNeedV5\n  ...BuyerNeedStatus_buyerNeedV5\n  agent {\n    ...AgentInfo_agent\n    nodeId\n  }\n  ...BuyerNeedSearchResultTimestamp_buyerNeed\n}\n\nfragment BuyerNeedStatus_buyerNeedV5 on BuyerNeedV5 {\n  status {\n    __typename\n    ... on ActiveBuyerNeed {\n      __typename\n    }\n    ... on ExpiredBuyerNeed {\n      __typename\n    }\n    ... on InContractBuyerNeed {\n      __typename\n    }\n    ... on PurchasedBuyerNeed {\n      __typename\n    }\n    ... on WithdrawnBuyerNeed {\n      __typename\n    }\n  }\n}\n\nfragment ClientNeedsPageRelayBuying_query_pbnwq on Query {\n  searchBuyerNeeds(areaIds: $areaIds, propertyTypes: $buyerNeedPropertyTypes, statuses: $buyerNeedStatuses, maxPrice: $maxPrice, minPrice: $minPrice, first: $first, after: $after, before: $before, last: $last, keywords: $keywords) @skip(if: $rentalMode) {\n    pageInfo {\n      hasNextPage\n      endCursor\n      hasPreviousPage\n      startCursor\n    }\n    totalCount\n    edges {\n      node {\n        id\n        ...BuyerNeedSearchResult_buyerNeed\n        nodeId\n      }\n    }\n  }\n}\n\nfragment PriceRangeCriteria_priceRange on PriceRange {\n  minPrice {\n    formatted(format: SHORT)\n  }\n  maxPrice {\n    formatted(format: SHORT)\n  }\n}\n",
    "providedVariables": providedVariablesDefinition
  }
};
})());
}

let node = makeNode(providedVariablesDefinition);

function load(environment, variables, fetchPolicy, fetchKey, networkCacheConfig) {
  return ReactRelay.loadQuery(environment, node, convertVariables(variables), {
    fetchKey: fetchKey,
    fetchPolicy: fetchPolicy,
    networkCacheConfig: networkCacheConfig
  });
}

function queryRefToObservable(token) {
  return Primitive_option.fromNullable(token.source);
}

function queryRefToPromise(token) {
  return new Promise((resolve, _reject) => {
    let o = queryRefToObservable(token);
    if (o !== undefined) {
      Primitive_option.valFromOption(o).subscribe({
        complete: () => resolve({
          TAG: "Ok",
          _0: undefined
        })
      });
      return;
    } else {
      return resolve({
        TAG: "Error",
        _0: undefined
      });
    }
  });
}

exports.Types = Types;
exports.Internal = Internal;
exports.Utils = Utils;
exports.providedVariablesDefinition = providedVariablesDefinition;
exports.node = node;
exports.load = load;
exports.queryRefToObservable = queryRefToObservable;
exports.queryRefToPromise = queryRefToPromise;
/* node Not a pure module */
